import { fork, put, all, call, takeLatest, delay } from "redux-saga/effects";

import {
  ADD_ORGANIZATION,
  UPDATE_ORGANIZATION,
  DELETE_ORGANIZATION,
  GET_ORGANIZATIONS,
  GET_PRE_ON_BOARDED_ORGANIZATIONS,
  RESEND_ORG_ON_BOARD_ACTIVATION_LINK,
  REGISTER_TRIAL_ACCOUNT_USER,
  CLEAR_ALL_MESSAGES,
  CLEAR_SUCCESS_MESSAGES,
  CLEAR_FAILURE_MESSAGES,
} from "./actionTypes";

import {
  addOrganization as addOrganizationAction,
  addOrganizationSuccess,
  addOrganizationFailed,
  updateOrganization as updateOrganizationAction,
  updateOrganizationSuccess,
  updateOrganizationFailed,
  deleteOrganization as deleteOrganizationAction,
  deleteOrganizationSuccess,
  deleteOrganizationFailed,
  getOrganizations as getOrganizationsAction,
  getOrganizationsSuccess,
  getOrganizationsFailed,
  getPreOnBoardedOrganizations as getPreOnBoardedOrganizationsAction,
  getPreOnBoardedOrganizationsSuccess,
  getPreOnBoardedOrganizationsFailed,
  resendOrgOnBoardActionLink as resendOrgOnBoardActionLinkAction,
  resendOrgOnBoardActionLinkSuccess,
  resendOrgOnBoardActionLinkFailure,
  registerTrialAccountUser as registerTrialAccountUserAction,
  registerTrialAccountUserSuccess,
  registerTrialAccountUserFailure,
  clearAllMessagesSuccess as clearAllMessagesSuccessAction,
  clearSuccessMessagesSuccess as clearSuccessMessagesSuccessAction,
  clearFailureMessagesSuccess as clearFailureMessagesSuccessAction,
} from "./actions";

import {
  deleteProspectiveSellRecordSuccessful,
  deleteProspectiveSellRecordFailure,
  clearAllDeleteProspectiveSellRecordMessages,
} from "./deleteProspectiveSellRecordSlice";

import {
  getOrganizations as getOrganizationsApi,
  getPreOnBoardedOrganizations as getPreOnBoardedOrganizationsApi,
  resendOrgOnboardActivationLink as resendOrgOnboardActivationLinkApi,
  addOrganization as addOrganizationApi,
  updateOrganization as updateOrganizationApi,
  deleteOrganization as deleteOrganizationApi,
  registerTrialAccountUser as registerTrialAccountUserApi,
  deletePreOnBoardedOrganizations as deleteProspectiveSellRecordApi,
} from "../../helpers/auth_helper";

function* addOrganization({ payload: { organization } }) {
  try {
    console.log("Saga, addOrganization, Organization :: ", organization);
    const response = yield call(addOrganizationApi, {
      // Add fields for organization, as per POST API request format
      // firstname: organization.firstname,
      // lastname: organization.lastname,
    });
    console.log("addOrganizationApi called, received response: ", response);
    yield put(addOrganizationSuccess(response));
    // yield delay(2000);
    // yield put(getOrganizationsAction());
  } catch (error) {
    console.log("addOrganizationApi called, received Error is :: ", error);
    yield put(addOrganizationFailed(error));
  }
}

function* updateOrganization({ payload: { organization } }) {
  try {
    console.log("Saga, updateOrganization, Organization :: ", {
      orgcode: organization.orgcode,
      orgname: organization.orgname,
      orgmetadata: organization.orgmetadata,
      orgdescription: organization.orgdescription,
      orgprimaryname: organization.orgprimaryname,
      orgaddress: organization.orgaddress,
      orgcity: organization.orgcity,
      orgstate: organization.orgstate,
      orgcountry: organization.orgcountry,
      orgzip: organization.orgzip,
      orgbillingname: organization.orgbillingname,
      orgbillingaddress: organization.orgbillingaddress,
      orgbillingstate: organization.orgbillingstate,
      orgbillingcountry: organization.orgbillingcountry,
      orgbillingzip: organization.orgbillingzip,
      orgbillingcity: organization.orgbillingcity,
      phonenumber: organization.phonenumber,
      numUsers: organization.numUsers,
      numAccounts: organization.numAccounts,
    });

    const response = yield call(updateOrganizationApi, organization);
    console.log("updateOrganizationApi called, received response: ", response);
    yield put(updateOrganizationSuccess());
    yield delay(2000);
    yield put(getOrganizationsAction());
  } catch (error) {
    console.log("updateOrganizationApi called, received Error is :: ", error);
    yield put(updateOrganizationFailed(error));
  }
}

function* deleteOrganization({ payload: { orgCode } }) {
  try {
    console.log("Saga, deleteOrganization, Org code :: ", orgCode);
    const response = yield call(deleteOrganizationApi, orgCode);
    console.log("deleteOrganizationApi called, received response: ", response);
    yield put(deleteOrganizationSuccess());
    yield delay(2000);
    yield put(getOrganizationsAction());
  } catch (error) {
    console.log("deleteOrganizationApi called, received Error is :: ", error);
    yield put(deleteOrganizationFailed(error));
  }
}

function* getOrganizations() {
  try {
    console.log("saga, getOrganizations ::");
    //TODO: pass input parameter
    const response = yield call(getOrganizationsApi);

    if (response && response.status === 200) {
      console.log(
        "getOrganizationsApi called successfully, received response: ",
        response
      );
      delete response.status;
      yield put(getOrganizationsSuccess(response));
    } else {
      console.log(
        "getOrganizationsApi call failed, received response: ",
        response
      );
      yield put(getOrganizationsFailed(response));
    }
  } catch (error) {
    console.log("getOrganizationsApi called, received error: ", error);
    yield put(getOrganizationsFailed(error));
  }
}

function* getPreOnBoardedOrganizations({ payload }) {
  try {
    const response = yield call(getPreOnBoardedOrganizationsApi);
    console.log("getPreOnBoardedOrganizations Response: ", response);
    if (response && response.status === 200) {
      delete response.status;
      yield put(getPreOnBoardedOrganizationsSuccess(response));
    } else {
      let message;
      if (response.message) {
        message = response.message;
      } else {
        message = response;
      }
      yield put(getPreOnBoardedOrganizationsFailed({ message: message }));
    }
  } catch (error) {
    console.log("addOrgUserApi Error: ", error);
    if (error.response) {
      yield put(
        getPreOnBoardedOrganizationsFailed({
          message:
            "Error Code: " +
            error.response?.status +
            ", Message: " +
            error.response?.data,
        })
      );
    } else if (error.request) {
      yield put(
        getPreOnBoardedOrganizationsFailed({
          message: "No response is received",
        })
      );
    } else {
      yield put(
        getPreOnBoardedOrganizationsFailed({ message: error?.message })
      );
    }
  }
}

function* deleteProspectiveSellRecord({ payload: token }) {
  try {
    const response = yield call(deleteProspectiveSellRecordApi, token);
    console.log("deleteProspectiveSellRecord, response ::: ", response);

    if (response && response.status === 200) {
      delete response.status;
      const message = Object.values(response);
      yield put(deleteProspectiveSellRecordSuccessful(message));
    } else {
      yield put(deleteProspectiveSellRecordFailure({ message: response.data }));
    }
  } catch (error) {
    if (error.response) {
      yield put(
        deleteProspectiveSellRecordFailure({
          message: `${error.response.data}`,
        })
      );
    } else if (error.request) {
      yield put(
        deleteProspectiveSellRecordFailure({ message: "No response received" })
      );
    } else {
      yield put(deleteProspectiveSellRecordFailure({ message: error.message }));
    }
  }
}

function* resendOrgOnBoardActionLink({ payload: { token } }) {
  try {
    const response = yield call(resendOrgOnboardActivationLinkApi, token);
    console.log("resendOrgOnBoardActionLink Response: ", response);
    if (response && response.status === 200) {
      delete response.status;
      yield put(resendOrgOnBoardActionLinkSuccess(response.data));
    } else {
      let message;
      if (response.message) {
        message = response.message;
      } else {
        message = response;
      }
      yield put(resendOrgOnBoardActionLinkFailure({ message: message }));
    }
  } catch (error) {
    console.log("addOrgUserApi Error: ", error);
    if (error.response) {
      yield put(
        resendOrgOnBoardActionLinkFailure({
          message: error.response?.data,
        })
      );
    } else if (error.request) {
      yield put(
        resendOrgOnBoardActionLinkFailure({
          message: "No response is received",
        })
      );
    } else {
      yield put(resendOrgOnBoardActionLinkFailure({ message: error?.message }));
    }
  }
}

function* registerTrialAccountUser({ payload: { user } }) {
  try {
    console.log("Saga, registerTrialAccountUser, User :: ", user);
    const response = yield call(registerTrialAccountUserApi, {
      // Add fields for organization/trial, as per POST API request format
      firstName: user.firstName,
      lastName: user.lastName,
      phoneNumber: user.phoneNumber,
      email: user.email,
      workAddress: user.workAddress,
      zipcode: user.zipcode,
      city: user.city,
      province: user.province,
      country: user.country,
      company: user.company,
      comments: user.comments,
      maxusers: user.maxusers,
      maxacounts: user.maxacounts,
      registrationtype: user.registrationtype,
    });
    console.log(
      "registerTrialAccountUserApi called, received response: ",
      response
    );
    if (response && response.status === 200) {
      yield put(registerTrialAccountUserSuccess(response.data));
    } else {
      yield put(registerTrialAccountUserFailure({ message: response.data }));
    }
  } catch (error) {
    console.log(
      "registerTrialAccountUserApi called, received Error is :: ",
      error
    );
      if (error.response) {
        yield put(
          registerTrialAccountUserFailure({
            message: `${error.response.data}`,
          })
        );
      } else if (error.request) {
        yield put(
          registerTrialAccountUserFailure({
            message: "No response received",
          })
        );
      } else {
        yield put(
          registerTrialAccountUserFailure({ message: error.message })
        );
      }
  }
}
export function* clearAllMessages() {
  console.log("Saga: clear all messages");
  yield put(clearAllMessagesSuccessAction());
}

export function* clearSuccessMessages(){
  console.log("Saga: clear success messages");
  yield put(clearSuccessMessagesSuccessAction());
}

export function* clearFailureMessages() {
  console.log("Saga: clear failure messages");
  yield put(clearFailureMessagesSuccessAction());
}

export function* watchOrganizations() {
  yield takeLatest(ADD_ORGANIZATION, addOrganization);
  yield takeLatest(UPDATE_ORGANIZATION, updateOrganization);
  yield takeLatest(DELETE_ORGANIZATION, deleteOrganization);
  yield takeLatest(
    "deleteProspectiveSellRecordSlice/deleteProspectiveSellRecord",
    deleteProspectiveSellRecord
  );
  yield takeLatest(
    "deleteProspectiveSellRecordSlice/clearAllDeleteProspectiveSellRecordMessages",
    clearAllDeleteProspectiveSellRecordMessages
  );
  yield takeLatest(GET_ORGANIZATIONS, getOrganizations);
  yield takeLatest(
    GET_PRE_ON_BOARDED_ORGANIZATIONS,
    getPreOnBoardedOrganizations
  );
  yield takeLatest(
    RESEND_ORG_ON_BOARD_ACTIVATION_LINK,
    resendOrgOnBoardActionLink
  );
  yield takeLatest(REGISTER_TRIAL_ACCOUNT_USER, registerTrialAccountUser);
  yield takeLatest(CLEAR_ALL_MESSAGES, clearAllMessages);
  yield takeLatest(CLEAR_SUCCESS_MESSAGES, clearSuccessMessages);
  yield takeLatest(CLEAR_FAILURE_MESSAGES, clearFailureMessages);
}

function* organizationSaga() {
  yield all([fork(watchOrganizations)]);
}

export default organizationSaga;